export default function MySQL_LCASE() {
  return (
    <div>
      <h2>MySQL_LCASE</h2>    </div>
  );
}